window.ChooseCompany = {
    init() {
        this.handleAnalytics();
        this.handleSearch();
    },

    handleAnalytics() {
        const setupAnalytics = () => {
            const requestAccessButtons = document.querySelectorAll("#request-access-btn");
            requestAccessButtons.forEach(button => {
                button.addEventListener("click", () => {
                    window.analytics.track(ANALYTICS_EVENTS.REQUEST_ACCESS_SELECTED, {
                        company_name: button.dataset.companyName
                    })
                })
            });

            const addNewCompanyButton = document.getElementById("add-new-company-btn");
            addNewCompanyButton.addEventListener("click", function (e) {
                window.analytics.track(ANALYTICS_EVENTS.ADD_NEW_COMPANY_SELECTED);
            });
        };

        if (window.analytics) {
            setupAnalytics();
        } else {
            document.addEventListener('analyticsReady', setupAnalytics, {once: true});
        }
    },

    handleSearch() {
        const searchInputElement = document.getElementById('search-input');
        if (searchInputElement) {
            searchInputElement.addEventListener('input', () => {
                const searchInput = searchInputElement.value.toLowerCase();
                const companies = document.querySelectorAll('.company');

                companies.forEach((company) => {
                    const companyName = company.getAttribute('data-company-name').toLowerCase();
                    if (companyName.includes(searchInput)) {
                        company.style.display = "flex";
                    } else {
                        company.style.display = "none";
                    }
                });
            });
        }
    }
};
